var swiper = new Swiper(".banner-slider", {
    pagination: {
        el: ".swiper-pagination",
    },
    // autoplay: {
    //     delay: 3500,
    //     disableOnInteraction: false,
    // },
});


